import { useMemo } from "react"
import { useFormContext } from "react-hook-form"
import { Box, Step, StepContent, StepLabel, Stepper, Typography } from "@mui/material"
import Step01 from "./Step01"
import Step02 from "./Step02"
import Step03 from "./Step03"
import InfoStep01 from "./Step01/InfoStep01"
import InfoStep02 from "./Step02/InfoStep02"
import InfoStep03 from "./Step03/InfoStep03"
import Step04 from "./Step04"
import InfoStep04 from "./Step04/InfoStep04"
import Step05 from "./Step05"
import InfoStep05 from "./Step05/InfoStep05"
import StepAprovacao from "./StepAprovacao"
import InfoStepAprovacao from "./StepAprovacao/InfoStepAprovacao"

export default function StepperIncluirPagamento() {

    const { watch, getValues } = useFormContext()

    const activeStep = watch('stepper')
    const is_parcelado = watch('step02.is_parcelado')
    const permissaoCriacaoTitulo = getValues('step_aprovacao.option') === 'abrir_solicitacao'

    const steps: Array<ISteps> = useMemo(() => {
        const steps: Array<ISteps> = [
            {
                label: "Identificação",
                component: <Step01 />,
                info: <InfoStep01 />
            },
            {
                label: "Valores",
                component: <Step02 />,
                info: <InfoStep02 />
            },
        ]

        if (permissaoCriacaoTitulo) {
            steps.push(
                {
                    label: "Aprovação",
                    component: <StepAprovacao />,
                    info: <InfoStepAprovacao />
                },
            )
            return steps
        }

        steps.push(
            {
                label: "Aprovação",
                component: <StepAprovacao />,
                info: <InfoStepAprovacao />
            },
            {
                label: "Informações contábeis",
                component: <Step03 />,
                info: <InfoStep03 />
            },
            {
                label: "Rateio",
                component: <Step04 />,
                info: <InfoStep04 />
            }
        )

        if (is_parcelado === 'false') {
            steps.push({
                label: "Retenção",
                component: <Step05 />,
                info: <InfoStep05 />
            });
        }
        return steps
    }, [permissaoCriacaoTitulo, is_parcelado])

    return (
        <Stepper activeStep={activeStep} orientation="vertical">
            {
                steps.map((step, index) => (
                    <Step key={step.label}>
                        <StepLabel
                            sx={{ alignItems: 'flex-start' }}
                            optional={
                                index < activeStep ?
                                    <Box sx={{
                                        pl: 4,
                                        top: 8,
                                        left: -20,
                                        position: 'relative',
                                        borderLeft: "1px solid #bdbdbd",
                                    }}>
                                        {step.info}
                                    </Box>
                                    : null
                            }
                        >
                            <Typography marginBottom={2} color={activeStep === index ? '#000000' : 'rgba(0, 0, 0, 0.6)'} variant="subtitle1">{step.label}</Typography>
                        </StepLabel>
                        <StepContent>{step.component}</StepContent>
                    </Step>
                ))
            }

        </Stepper>
    )
}

interface ISteps {
    label: string,
    component: React.ReactNode,
    info: React.ReactNode
}

/* [
    {
        label: "Identificação",
        component: <Step01 />,
        info: <InfoStep01 />
    },
    {
        label: "Valores",
        component: <Step02 />,
        info: <InfoStep02 />
    },
    {
        label: "Informações contábeis",
        component: <Step03 />,
        info: <InfoStep03 />
    },
    {
        label: "Rateio",
        component: <Step04 />,
        info: <InfoStep04 />
    },
    {
        label: "Retenção",
        component: <Step05 />,
        info: <InfoStep05 />
    },
] */